import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { UserActivityView } from '../components/views/userActivityView'

function UserActivity() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataReady && !loading) {
            Loading.circle('Loading...')
            setLoading(true)
            checkAuth()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataReady, loading])

    // Same gate as the Users page: `/users-page-auth` 403s non-admins.
    const checkAuth = async () => {
        try {
            await api('/users-page-auth')
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            Loading.remove()
            if (error?.response?.status === 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else if (error?.response?.status === 403) {
                Report.failure(
                    'Access Denied',
                    'User Activity is restricted to Sentinel admin users only.',
                    'Return to Dashboard',
                    () => navigate('/home'),
                )
            } else {
                Report.failure('Access Denied', 'You do not have permission to view this page.', 'Okay', () =>
                    navigate('/home'),
                )
            }
        }
    }

    return (
        <div className="userActivity">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="User Activity"
                        intro="What each dashboard user has been viewing and searching for, by organisation. Click a visit to see the requests behind it."
                    />
                    {dataReady ? <UserActivityView /> : <></>}
                </Page>
            </MainView>
        </div>
    )
}

export default UserActivity
